import {
	renderViewDefault,
	renderTrackHorizontalDefault,
	renderTrackVerticalDefault,
	renderThumbHorizontalDefault,
	renderThumbVerticalDefault
} from './defaultRenderElements';

export function getInnerHeight(el) {
	const { clientHeight } = el;
	const { paddingTop, paddingBottom } = getComputedStyle(el);
	return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

export function getInnerWidth(el) {
	const { clientWidth } = el;
	const { paddingLeft, paddingRight } = getComputedStyle(el);
	return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}
let scrollbarWidth = false;

export function css(element, styles) {
	for (const key of Object.keys(styles)) {
		element.style[key] = styles[key];
	}
}

export function getScrollbarWidth(cacheEnabled = true) {
	if (cacheEnabled && scrollbarWidth !== false) return scrollbarWidth;
	/* istanbul ignore else */
	if (typeof document !== 'undefined') {
		const div = document.createElement('div');
		css(div, {
			width: '100px',
			height: '100px',
			position: 'absolute',
			top: '-9999px',
			overflow: 'scroll',
			'-ms-overflow-style': 'scrollbar'
		});
		document.body.appendChild(div);
		scrollbarWidth = div.offsetWidth - div.clientWidth;
		document.body.removeChild(div);
	} else {
		scrollbarWidth = 0;
	}
	return scrollbarWidth || 0;
}

export function isString(maybe) {
	return typeof maybe === 'string';
}

export function returnFalse() {
	return false;
}

export function addDefaultProps({
	renderView = renderViewDefault,
	renderTrackHorizontal = renderTrackHorizontalDefault,
	renderTrackVertical = renderTrackVerticalDefault,
	renderThumbHorizontal = renderThumbHorizontalDefault,
	renderThumbVertical = renderThumbVerticalDefault,
	tagName = 'div',
	thumbMinSize = 30,
	hideTracksWhenNotNeeded = false,
	autoHide = false,
	autoHideTimeout = 1000,
	autoHideDuration = 200,
	autoHeight = false,
	autoHeightMin = 0,
	autoHeightMax = 200,
	universal = false,
	...props
}) {
	return {
		renderView,
		renderTrackHorizontal,
		renderTrackVertical,
		renderThumbHorizontal,
		renderThumbVertical,
		tagName,
		thumbMinSize,
		hideTracksWhenNotNeeded,
		autoHide,
		autoHideTimeout,
		autoHideDuration,
		autoHeight,
		autoHeightMin,
		autoHeightMax,
		universal,
		...props
	};
}
